import Splide from '@splidejs/splide';

export default {

	selectors: {
		splide: '.process-splide',
		next: '.process-next',
		prev: '.process-prev',
	},

	classes: {
		active: 'opacity-40',
	},

	init() {
		if (!document.querySelectorAll(this.selectors.splide).length) return;
		const prev = document.querySelector(this.selectors.prev);
		const next = document.querySelector(this.selectors.next);

		const process = new Splide(document.querySelector(this.selectors.splide), {
			arrows: false,
			pagination: false,
		});
		process.mount();

		process.on('move', (slideIndex) => {
			prev.classList.toggle(this.classes.active, slideIndex === 0);
			next.classList.toggle(this.classes.active, (slideIndex + 1) === process.length);
		});

		prev.addEventListener('click', (event) => {
			event.preventDefault();
			process.go('-');
		});

		next.addEventListener('click', (event) => {
			event.preventDefault();
			process.go('+');
		});
	},

};
